import { memo } from 'react';

import { Option, Select } from '@/lib/v2/components';

import { ConditionState } from '@/modules/AutomationModuleNew/atoms/flows';
import { useBinaryConditional } from '@/modules/AutomationModuleNew/hooks/Journeys';

interface ConditionalProps {
  groupsOptions: Option[];
  tagsOptions: Option[];
  index: number;
  conditionState: ConditionState;
}
const Conditional = ({ groupsOptions, tagsOptions, index, conditionState }: ConditionalProps) => {
  const { selectBelongValue, selectIdsValues, selectTypeValue } = conditionState;
  const {
    handleSelectTypeChange,
    handleSelectBelongChange,
    handleSelectIdsChange,
    selectTypesOptions,
    selectBelongOptions,
  } = useBinaryConditional(index);

  return (
    <div className="relative flex w-full flex-col gap-1">
      <Select
        withSearch
        name="selectTypes"
        options={selectTypesOptions}
        value={selectTypeValue}
        onChange={handleSelectTypeChange}
      />
      <Select
        withSearch
        name="selectBelong"
        options={selectBelongOptions}
        value={selectBelongValue}
        onChange={handleSelectBelongChange}
      />
      <Select
        multiSelect
        withSearch
        name="selectIds"
        options={selectTypeValue.value === 'belongsToGroups' ? groupsOptions : tagsOptions}
        value={selectIdsValues}
        onChange={handleSelectIdsChange}
      />
    </div>
  );
};

export default memo(Conditional);
